// extracted by mini-css-extract-plugin
module.exports = {"Tip":"Tip__7dQTt","Tip--isFlush":"Tip--isFlush__13IVk","Tip__arrow":"Tip__arrow__Trw2S","Tip--widthAuto":"Tip--widthAuto__349Rw","Tip--blue":"Tip--blue__2WzRE"};